import { Stack, Typography } from "@mui/material";
import { ReactNode } from "react";

type Props = {
  title: string;
  texts: string[];
  btn: ReactNode;
  bgColor?: string;
  border?: string;
};

export const GoToActionBlock = ({
  title,
  texts,
  btn,
  bgColor = "#FFF7E5",
  border = "1px solid #D9D9D9",
}: Props) => {
  return (
    <Stack
      direction="row"
      gap="16px"
      borderRadius="6px"
      bgcolor={bgColor}
      padding="16px"
      alignItems="flex-start"
      border={border}
    >
      <Stack
        direction="row"
        justifyContent="space-between"
        alignItems="center"
        flexGrow={1}
        gap="24px"
      >
        <Stack gap="4px">
          <Typography
            variant="subtitle1"
            color="custom.textDarkBlue"
            sx={{ fontWeight: 500 }}
          >
            {title}
          </Typography>

          {texts && (
            <Stack>
              {texts.map((text) => (
                <Typography key={text} variant="body1" color="text.secondary">
                  {text}
                </Typography>
              ))}
            </Stack>
          )}
        </Stack>
        {btn}
      </Stack>
    </Stack>
  );
};
